<template>
  <div class="LoaderComponent">
    <span class="loader" :class="[type, { light }]" />
  </div>
</template>

<script lang="ts" setup>
defineProps({
  type: {
    type: String,
    default: 'primary'
  },
  light: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.loader {
  width: 3rem;
  height: 3rem;
  border: var(--size-md) solid rgb(var(--color-aquamarine-700-opa-30));
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin-bottom: $spacing-2xl;

  &.light {
    border-color: var(--vt-c-white);
  }


  &.primary {
    border-bottom-color: var(--vt-c-primary);
  }

  &.secondary {
    border-bottom-color: var(--vt-c-secondary);
  }

  &.secondary-commercial {
    border-bottom-color: var(--vt-c-secondary-commercial);
  }

  .redirect & {
    width:4rem;
    height:4rem;
    margin: 0;
  }
}



@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
